export default {
  SET_ACTOR_DATA: (state, payload) => state.actorData.data = payload,
  SET_ACTOR_LOADING: (state, payload) => state.actorData.loading = payload,
  SET_ACTOR_ERROR: (state, payload) => state.actorData.error = payload,
}